import React from 'react';
import HighlightNeedOfferItem from './HighlightNeedOfferItem.jsx';
import {Demands} from 'api';
import {withRouter} from 'react-router-dom';

class HighlightNeedOfferList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 3,
      order: 'id DESC'
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          isApprove: true
        }
      }
    };
    Demands.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    return (
      <div className="list-highlight-need-offer">
        {
          this.state.data.map((item, i) => {
            return (
              <HighlightNeedOfferItem key={i} item={item}/>
            );
          })
        }
      </div>
    );
  }
}

export default withRouter(HighlightNeedOfferList);



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightNeedOffer/HighlightNeedOfferList.jsx